export default "__VITE_ASSET__DzyIWIpt__"